// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607291545/js/" + chunkId + "." + {"44":"62c4ddf3","225":"3f61680d","481":"2ffb4499","486":"803bd03c","770":"f52d839a"}[chunkId] + ".0.060981646794993405.chunk.js";
};